// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"17":"b81c139d","95":"463b72ea","150":"a1f09123","298":"6ea9a28c","349":"93aecca4","433":"79d09491","453":"eebabdf2","478":"38606561","482":"b5b6ed1e","777":"4781248d","895":"520fa344"}[chunkId] + ".chunk.js";
};